<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['submit']);

const { t } = useI18n();
const getters = useStoreGetters();

const dialogRef = ref(null);
const selectedLabels = ref([]);

const accountLabels = computed(() => getters['labels/getLabels'].value);

const isFormComplete = computed(() => selectedLabels.value.length > 0);

const close = () => {
  dialogRef.value?.close();
};

const open = (initialLabels = []) => {
  selectedLabels.value = [...initialLabels];
  dialogRef.value?.open();
};

const handleConfirm = () => {
  if (!isFormComplete.value) return;
  emit('submit', { labels: selectedLabels.value });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="sm"
    :title="t('CONVERSATION_WORKFLOW.RESOLVE_LABEL.MODAL.TITLE')"
    :description="t('CONVERSATION_WORKFLOW.RESOLVE_LABEL.MODAL.DESCRIPTION')"
    :confirm-button-label="
      t('CONVERSATION_WORKFLOW.RESOLVE_LABEL.MODAL.ACTIONS.RESOLVE')
    "
    :cancel-button-label="
      t('CONVERSATION_WORKFLOW.RESOLVE_LABEL.MODAL.ACTIONS.CANCEL')
    "
    :disable-confirm-button="!isFormComplete"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-1 max-h-80 overflow-y-auto">
      <label
        v-for="label in accountLabels"
        :key="label.id"
        class="flex items-center gap-2 py-1.5 px-2 rounded-lg cursor-pointer hover:bg-n-slate-3"
      >
        <input
          v-model="selectedLabels"
          type="checkbox"
          :value="label.title"
          class="shrink-0"
        />
        <span
          class="w-2.5 h-2.5 rounded-full shrink-0"
          :style="{ backgroundColor: label.color }"
        />
        <span class="text-sm text-n-slate-12">{{ label.title }}</span>
      </label>
      <p v-if="!accountLabels.length" class="text-sm text-n-slate-11">
        {{ t('CONVERSATION_WORKFLOW.RESOLVE_LABEL.MODAL.EMPTY') }}
      </p>
    </div>
  </Dialog>
</template>
